export default {
  apiUrl: '/api/wineries',
  dataPath: 'result.rows',
  paginationPath: 'data',
  trackBy: 'id',
  detailRowComponentName: 'winery-editor',
  onEachSide: 1,
  preloadList: [],
  sortOrder: [{
    field: 'id',
    sortField: 'id',
    direction: 'DESC',
  }],
  paginationTemplate: {
    class: '',
    template: '총 {total}개 중의 {from} 부터 {to}',
  },
  fields: [
    {
      name: '__checkbox',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
    {
      name: '__slot:actions',
      title: '편집 삭제',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
    {
      name: 'id',
      title: '<p style="white-space: nowrap">아이디</p>',
      sortField: 'id',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'name',
      title: '<i style="white-space: nowrap">한글 이름</i>',
      sortField: 'name',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'name_en',
      title: '<i style="white-space: nowrap">영어 이름</i>',
      sortField: 'name_en',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'latitude',
      title: '<i style="white-space: nowrap">위도</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'longitude',
      title: '<i style="white-space: nowrap">경도</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'map_zoom',
      title: '<i style="white-space: nowrap">확대</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'is_checked',
      title: '<p style="white-space: nowrap">발행</p>',
      sortField: 'is_checked',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'toggleField',
    },
    {
      name: '__slot:actions',
      title: '편집 삭제',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
  ],
  check_sms_permitted : false,
};



// WEBPACK FOOTER //
// ./src/spa/components/board/winery/Config.js